(() => {
  'use strict';

  let body;
  let savedNodes = [];

  const observer = new MutationObserver((records) => {
    const screen = document.getElementById('np-root');
    const text = screen ? screen.textContent : '';
    const knownBlock = screen && /shrine/i.test(text) && /unauthorized\s+copy/i.test(text);

    if (knownBlock) {
      observer.disconnect();
      if (document.getElementById('MainContent')) {
        screen.remove();
      } else if (savedNodes.length) {
        body.replaceChildren(...savedNodes);
      }
      savedNodes = Array.from(body.childNodes);
      observer.observe(body, { childList: true, subtree: true });
      return;
    }

    if (records.some((record) => record.target === body)) {
      savedNodes = Array.from(body.childNodes);
    }
  });

  const start = () => {
    body = document.body;
    if (!body || !document.getElementById('MainContent')) return;
    savedNodes = Array.from(body.childNodes);
    observer.observe(body, { childList: true, subtree: true });
  };

  if (document.body && document.getElementById('MainContent')) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();
